import { get as dig } from 'lodash';
import * as immutable from 'object-path-immutable';

import { useMutation } from '@apollo/client';

import PROJECT_COLLABORATION_DELETE_MUTATION from 'components/projects/collaboration/gql/ProjectCollaborationDeleteMutation.graphql.js';
import PROJECT_COLLABORATION_QUERY from 'components/projects/collaboration/gql/ProjectCollaborationQuery.graphql.js';

const useProjectCollaborationDelete = ({
  collaborationId,
  projectNodeId,
  onSuccess = () => {},
}) => {
  const [projectCollaborationDelete, { loading }] = useMutation(
    PROJECT_COLLABORATION_DELETE_MUTATION,
    {
      update: (cache, { data }) => {
        const deletedId = dig(
          data,
          'projectCollaborationDelete.deletedId',
          null,
        );

        const oldData = cache.readQuery({
          query: PROJECT_COLLABORATION_QUERY,
          variables: { id: projectNodeId },
        });
        const newEdges = dig(
          oldData,
          'viewer.project.collaborations.edges',
          [],
        ).filter(
          ({ node: existingCollaboration }) =>
            existingCollaboration.id !== deletedId,
        );

        let newData = immutable.set(
          oldData,
          'viewer.project.collaborations.totalCount',
          Math.max(newEdges.length, 0),
        );
        newData = immutable.set(
          newData,
          'viewer.project.collaborations.edges',
          newEdges,
        );

        cache.writeQuery({
          query: PROJECT_COLLABORATION_QUERY,
          variables: { id: projectNodeId },
          data: newData,
        });
      },
      onCompleted: () => {
        onSuccess();
      },
    },
  );

  const deleteProjectCollaboration = () => {
    projectCollaborationDelete({
      variables: {
        input: {
          id: collaborationId,
        },
      },
    });
  };

  return { deleteProjectCollaboration, loading };
};

export default useProjectCollaborationDelete;
